import { getAuthoredOverview, renderAuthoredNarrativeBundle } from './authoredNarrativeRender';
import { shouldPublishAuthoredMethodology } from './authoredNarrativeLoader';

const CHART_ID = 'educational_attainment';

export type EducationalAttainmentViewId = 'trends' | 'chart' | 'map';

export function buildEducationalAttainmentTokens(params: {
  locationName: string;
  latestYear: number | null;
  selectedAttainmentShare: number | null;
  selectedAttainmentCategory: string;
  compositionSentence: string;
  trendSentence: string;
}): Record<string, string> {
  return {
    locationName: params.locationName,
    latestYear: params.latestYear != null ? String(params.latestYear) : '—',
    selectedAttainmentShare:
      params.selectedAttainmentShare != null
        ? params.selectedAttainmentShare.toFixed(1)
        : '—',
    selectedAttainmentCategory: params.selectedAttainmentCategory,
    compositionSentence: params.compositionSentence,
    trendSentence: params.trendSentence,
  };
}

export function buildEducationalAttainmentAuthoredBundle(
  view: EducationalAttainmentViewId,
  params: {
    locationName: string;
    latestYear: number | null;
    selectedAttainmentShare: number | null;
    selectedAttainmentCategory: string;
    compositionSentence: string;
    trendSentence: string;
  }
) {
  const viewId = view === 'trends' ? 'default' : view === 'map' ? 'map' : 'default';
  const tokens = buildEducationalAttainmentTokens(params);
  const bundle = renderAuthoredNarrativeBundle(CHART_ID, viewId, tokens);
  if (!bundle.overview) {
    bundle.overview = getAuthoredOverview(CHART_ID, 'default', '');
  }
  if (!shouldPublishAuthoredMethodology(bundle.authoringStatus)) {
    bundle.methodology = undefined;
  }
  return bundle;
}

export function educationalAttainmentOverviewDescription(fallback: string): string {
  return getAuthoredOverview(CHART_ID, 'default', fallback);
}
